export enum ItemType {
    Empty = "empty",
    Default = "default",
    Consumable = "consumable",
}
